
export interface IPaginationResponse {
    totalCount?: number;
    pageSize?: number;
    currentPage?: number;
    totalPages?: number;
}
